import { sendMetrics } from '@jusbrasil-web/shared-utils-events'

const eventNamespace = 'BoxLock'
const eventPrefixName = 'FrameBus'

export type BoxLockFrameBusEventKind = 'Triggered' | 'Initialized' | 'Loaded' | 'Showed'

/**
 * FLOW: Triggered -> Initialized -> Loaded -> Showed
 * --------------------------------------------------
 * Triggered - FrameBus intended to create an iframe, otherwise, a box-lock should be triggered.
 * Initialized - FrameBus managed to create an iframe and the page inside the iframe was initialized.
 * Loaded - The resources of the box-lock in iframe's page were loaded and executed in the browser, now `showBoxLockModal` can be called.
 * Showed - The box-lock was shown to the user in the iframe by calling `showBoxLockModal`.
 */

export type BoxLockFrameBusEventProps = {
  appId?: string
  featureCode?: string
  fromComponent?: string
}

export function boxLockFrameBusEvent<K extends BoxLockFrameBusEventProps>(
  kind: BoxLockFrameBusEventKind,
  pid: number | undefined | null,
  data: K
): void {
  const { appId, featureCode, fromComponent } = data
  const eventName = `${eventNamespace}.${eventPrefixName}${kind}`
  sendMetrics(eventName, pid ? String(pid) : null, {
    appId,
    featureCode,
    fromComponent,
  })
}
